export const convertKilovoltAmperesToAmperes = (kVA: number, V: number) => {
  const isSinglePhase = V <= 230

  if (isSinglePhase) {
    return (kVA * 1000) / V
  } else {
    return (kVA * 1000) / (Math.sqrt(3) * V)
  }
}

export const convertKilovoltAmperesToKilowatts = (kVA: number, PF = 0.8) => {
  return kVA * PF
}

export const convertKilovoltAmperesToWatts = (kVA: number, PF = 0.8) => {
  return kVA * PF * 1000
}

export const convertKilowattsToAmperes = (kW: number, V: number, PF = 0.8) => {
  const kVA = convertKilowattsToKilovoltAmperes(kW, PF)
  return convertKilovoltAmperesToAmperes(kVA, V)
}

export const convertKilowattsToKilovoltAmperes = (kW: number, PF = 0.8) => {
  return kW / PF
}

export const convertKilowattsToWatts = (kW: number) => {
  return kW * 1000
}

export const convertAmperesToKilovoltAmperes = (A: number, V: number) => {
  const isSinglePhase = V <= 230
  if (isSinglePhase) {
    return (A * V) / 1000
  } else {
    return (Math.sqrt(3) * A * V) / 1000
  }
}

export const convertAmperesToKilowatts = (A: number, V: number, PF = 0.8) => {
  const kVA = convertAmperesToKilovoltAmperes(A, V)
  return convertKilovoltAmperesToKilowatts(kVA, PF)
}

export const convertAmperesToWatts = (A: number, V: number, PF = 0.8) => {
  const kW = convertAmperesToKilowatts(A, V, PF)
  return convertKilowattsToWatts(kW)
}

export const convertWattsToKilowatts = (W: number) => {
  return W / 1000
}
